import * as React from "react";
// import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * ## Custom Filter Select
 *
 * #### Filter Options:
 * `[{value: "true", label: "value"}]`
 *
 * #### Filter State Holder: `type: string`
 *
 * - Since this filter will only hold one value at any point in time,
 * param `filterStateHolder` will hold the corresponding string
 * value of the selected option - for this API use-case
 *
 * @param {string} filterName Text to display on the label
 * @param {string[]} filterOptions Array of objects containing label, id
 * @param {string} filterStateHolder useState value
 * @param setFilterStateHolder useState setter function
 * @param handleClear function to clear filter
 */
export default function CustomFilterSelect({
  filterName,
  filterOptions,
  filterStateHolder,
  setFilterStateHolder,
  // handleClear,
}) {
  // const [filterStateHolder, setFilterStateHolder] = React.useState("");

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    console.log("Value from select component: ", value);
    setFilterStateHolder(value);
    // On autofill we get a stringified value.
    // typeof value === "string" ? value.split(",") : value
  };

  // const filterOptions = [
  //   {
  //     value: 0,
  //     label: "Paid",
  //   },
  //   {
  //     value: 1,
  //     label: "Completed",
  //   },
  // ];

  return (
    <div>
      <FormControl
        sx={{ m: 1, minWidth: 150, margin: "0 16px 0 16px", fontSize: "14px" }}
        size="small"
        variant="standard"
      >
        <InputLabel id="demo-multiple-checkbox-label">{filterName}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          value={filterStateHolder}
          onChange={handleChange}
          renderValue={(selected) => {
            return filterOptions[selected].label // hard logic here, works only when the options are arranged numerically
          }}
          MenuProps={MenuProps}
        >
          <MenuItem value="">
            <Checkbox checked={filterStateHolder === ""} />
            <ListItemText primary={"Select none"} />
          </MenuItem>
          {filterOptions.map((filter) => (
            <MenuItem key={filter.value} value={filter.value}>
              <Checkbox checked={filterStateHolder === filter.value} />
              <ListItemText primary={filter.label} />
              
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
